/*
 * @Author: edvardchen
 * @Date:   2016-08-07 15:28:14
 * @Last Modified by: jerryfwang
 * @Last Modified time: 2020-09-07 15:42:09
 */

// flow
import _ from 'lodash';
import qs from 'query-string';
import isomorphicConfig from './isomorphicConfig';
import singleContentQBUrl from './singleContentQBUrl';
import redirect from './redirect';
import url from './url';
import { paramTruly, isQehId, isValidId, getIdType } from './rn/index';
import { getQBVersion } from './commentUtil';

export { isomorphicConfig, singleContentQBUrl, redirect, url, paramTruly, isQehId, isValidId, getIdType, getQBVersion };

const rEmptyGuid = /^[0\s]+$/;
export function isValidGuid(guid) {
  return Boolean(guid && !rEmptyGuid.test(guid));
}
export const isFastQBVersion = (pid, _qua) =>
  pid === '17' || (_qua || _.get(window, 'browser.env.qua2') || '').indexOf('PR=FF') > -1; // 极速版判断
export const shortString = (num) => (num > 1e4 ? `${(num / 1e4).toFixed(1)}万` : String(num));

export function isFusionId(id) {
  return id.indexOf('q_') === 0;
}

export const insertStr = (soure, start, newStr) => {
  return soure.slice(0, start) + newStr + soure.slice(start);
};

// export function paramTruly(value) {
//   return Boolean(value && value !== '0' && value !== 'false' && value !== 'undefined');
// }
export function clientIsRN() {
  if (!__CLIENT__) {
    return false;
  }
  const location = url.parse(window.location.href);
  const {
    query: { hippy, hi, rnfqb },
  } = location;
  return paramTruly(hippy) || paramTruly(hi) || paramTruly(rnfqb);
}

// 安全扫描判断
export const isTST = (ctx) => {
  if (!__CLIENT__) {
    return false;
  }
  const { 'user-agent': ua = '' } = ctx.headers || {};
  return ua.indexOf('Tencent_Security_Team') > -1;
};
export const isHippy = () => {
  if (!__CLIENT__) {
    return false;
  }
  const location = url.parse(window.location.href);
  const {
    query: { hippy, hi, rnfqb },
  } = location;
  return paramTruly(hippy) || paramTruly(hi) || paramTruly(rnfqb);
};
export const clientLogReport = ({ message, key, logName }: { message: *, key: string, logName: string }) => {
  if (!__CLIENT__) {
    return;
  }
  try {
    const body = {
      message: typeof message === 'object' ? JSON.stringify(message) : message,
      logName,
      key,
    };
    new window.Image().src = `https://news.html5.qq.com/api/logReport?__=${window.btoa(qs.stringify(body))}`;
  } catch (error) {
    console.log(error);
  }
};
export const isRaven = (ctx = {}) => {
  if (__CLIENT__) {
    return false;
  }
  const { host } = ctx;
  return isomorphicConfig.RavenOpen && !(host.indexOf('sparta') > -1 || host.indexOf('localhost') > -1);
};
export const grayStrategy = (percent) => {
  const key = 'changeLinkStrategy';
  const storage = require('./storage');
  let random = storage.localStorage.getItem(key);
  if (!random) {
    random = Math.ceil(Math.random() * 100);
    storage.localStorage.setItem(key, random);
  }
  if (random <= percent) {
    return true;
  }
  return false;
};
export const random = (start, end, isRound = true) => {
  if (start > end) {
    return 0;
  }
  const result = Math.random() * (end - start) + start;
  return isRound ? Math.round(result) : result;
};
export shouldContainerUpdate from './shouldContainerUpdate';
export humanizeDuration from './humanizeDuration';
export isSelfHostPath from './isSelfHostPath';
// export const isQehId = (id?:string = '') => /^qeh_/.test(id); // 判断是否是企鹅号
export const getGrayIdsByQuery = (query: Object) => {
  if (!__CLIENT__) {
    return '';
  }
  try {
    const { extenddata = '' } = query || {};
    const { sGrayPlatFormModelId = '' } = qs.parse(extenddata) || {};
    const grayIds = [...new Set(sGrayPlatFormModelId.split('#'))].join('#');
    return grayIds;
  } catch (error) {
    console.log('getGrayIdsByQuery-error', error);
  }
  return '';
};

export * from './commentUtil';
export * from './UA'; // user-agent 终端识别
export * from '@tencent/qb-article-util/lib/QUA'; // QUA 相关的一些识别，如是否支持终端评论

export getBusinessType from './getBusinessType';

export updateURLParams from './updateURLParams';

export number2percent from './number2percent';

export str2bool from './str2bool';

export withinShare from './withinShare';

// #if process.env.WEBPACK_ENV_TARGET === 'client'
export track from './track';
export { quanActionReport } from './track';
export getImageDimension from './getImageDimension';
export onVisibilityChange from './onVisibilityChange';
export shareQS from './shareQS';
export connection from './connection';
export postMessage from './postMessage';
export * from './articleData';
export * from './DOM';
export * from './storage';
// #endif

// #if process.env.WEBPACK_ENV_TARGET === 'server'
// export createGuid from './createGuid';
// export runOnTaf from './runOnTaf';
// export getLogger from './logger';
// export { getCtxMsgForLog } from './logger';
// export withLog from './withLog';
// export withMonitor from './withMonitor';
// export assets from './assets';
// #endif
export { getQbUserInfo, getAccountInfo, makeTagsInfo } from './mixinDataUtil';
